import React, { useState } from "react";
import LayoutDashboard from "../layout/LayoutDashboard";
import TabReport from "../components/Setting/TabReport";
import TabSlotDelivery from "../components/Setting/TabSlotDelivery";
import TabMaxTransaction from "../components/Setting/TabMaxTransaction";
import TabCloseDeliver from "../components/Setting/TabCloseDeliver";
import DynamicScrollToTop from "../components/misc/DynamicScrollToTop";
import TabFee from "../components/Setting/TabFee";

const Setting = () => {
  const [showTab, SetShowTab] = useState(1);
  return (
    <>
      <DynamicScrollToTop />
      <LayoutDashboard>
        <div className="bg-white w-full ml-4 h-full flex">
          <div className="flex flex-col w-3/12 pt-8 h-full">
            <div className="flex flex-col border-r border-gray-300 h-full">
              <button
                className={
                  "flex py-3  menu-sidebar" +
                  (showTab === 1
                    ? " border-orange-600 border-l-4 bg-orange-100"
                    : " pl-1 hover:bg-orange-100")
                }
                onClick={() => {
                  SetShowTab(1);
                }}
              >
                <span className="flex items-center mx-auto w-8/12">
                  <p className="text-basic-orange tracking-0-4 ml-4">Umum</p>
                </span>
              </button>
              <button
                onClick={() => {
                  SetShowTab(2);
                }}
                className={
                  "flex py-3  menu-sidebar" +
                  (showTab === 2
                    ? " border-orange-600 border-l-4 bg-orange-100"
                    : " pl-1 hover:bg-orange-100")
                }
              >
                <span className="flex items-center mx-auto w-8/12">
                  <p className=" tracking-0-4 ml-4">Maksimum Transaksi</p>
                </span>
              </button>
              <button
                onClick={() => {
                  SetShowTab(3);
                }}
                className={
                  "flex py-3  menu-sidebar" +
                  (showTab === 3
                    ? " border-orange-600 border-l-4 bg-orange-100"
                    : " pl-1 hover:bg-orange-100")
                }
              >
                <span className="flex items-center mx-auto w-8/12">
                  <p className=" tracking-0-4 ml-4">Slot Pengantaran</p>
                </span>
              </button>
              <button
                onClick={() => {
                  SetShowTab(4);
                }}
                className={
                  "flex py-3  menu-sidebar" +
                  (showTab === 4
                    ? " border-orange-600 border-l-4 bg-orange-100"
                    : " pl-1 hover:bg-orange-100")
                }
              >
                <span className="flex items-center mx-auto w-8/12">
                  <p className=" tracking-0-4 ml-4">Tutup Pesanan</p>
                </span>
              </button>
              <button
                onClick={() => {
                  SetShowTab(5);
                }}
                className={
                  "flex py-3  menu-sidebar" +
                  (showTab === 5
                    ? " border-orange-600 border-l-4 bg-orange-100"
                    : " pl-1 hover:bg-orange-100")
                }
              >
                <span className="flex items-center mx-auto w-8/12">
                  <p className=" tracking-0-4 ml-4">Ongkos Kirim</p>
                </span>
              </button>
            </div>
          </div>
          <div className="flex w-9/12 pt-8 lg:pl-12 pr-8">
            {showTab === 1 ? <TabReport /> : null}
            {showTab === 2 ? <TabMaxTransaction /> : null}
            {showTab === 3 ? <TabSlotDelivery /> : null}
            {showTab === 4 ? <TabCloseDeliver /> : null}
            {showTab === 5 ? <TabFee /> : null}
          </div>
        </div>
      </LayoutDashboard>
    </>
  );
};

export default Setting;
